import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'generic-error',
  templateUrl: './generic-error.component.html',
  styleUrls: ['./generic-error.component.scss'],
})
export class GenericErrorComponent implements OnInit {
  image: string;
  constructor() {
    this.image = '../../../../assets/images/went_wrong.svg';
  }
  ngOnInit() { }

}
